import React, { memo } from 'react'
import PropTypes from 'prop-types'
import infoStyles from '../../styles/tracker-modules/info.module.less'

const Info = ({ infoData, topper }) => {
  return (
    <section className="box-border" aria-label="Related stories">
      <h2 className="box-title">{topper}</h2>

      {infoData.map((item) => (
        <div key={item.title} className={infoStyles.story}>
          <p>
            <a className={infoStyles.link} href={item.url}>{item.title}</a>
          </p>
        </div>
      ))}
    </section>
  )
}
Info.propTypes = {
  infoData: PropTypes.array,
}
export default memo(Info)
